import { render, staticRenderFns } from "./WrButton.vue?vue&type=template&id=deafd6fc&scoped=true"
import script from "./WrButton.vue?vue&type=script&lang=js"
export * from "./WrButton.vue?vue&type=script&lang=js"
import style0 from "./WrButton.vue?vue&type=style&index=0&id=deafd6fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deafd6fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
